const nearestDesi = (value, liste) => {
  const aranan = Number(value);
  const siraliListe = [...liste].sort((a, b) => b.key - a.key);
  const sonuc = siraliListe.find((item) => aranan >= item.key);

  return sonuc || siraliListe[siraliListe.length - 1];
};

const getTotalDesi = (products = []) =>
  products.reduce((sum, product) => sum + Number(product?.desi || 0), 0);

export const recalculateProductsDesi = ({
  products,
  desiOptions,
  setDeliveryType,
  setDesi,
}) => {
  if (!products?.length) {
    return {
      deliveryType: undefined,
      manuelDesi: null,
      desi: undefined,
    };
  }

  const totalDesi = getTotalDesi(products);
  const nearest = nearestDesi(totalDesi, desiOptions || []);
  const desiKey = Number(nearest?.key);

  if (typeof setDeliveryType === "function") {
    setDeliveryType("TMH");
  }

  if (typeof setDesi === "function") {
    setDesi(desiKey);
  }

  return {
    deliveryType: "TMH",
    manuelDesi: totalDesi,
    desi: desiKey,
  };
};

const getParcelValues = (products, syncTotalParcels) =>
  syncTotalParcels ? { totalParcels: products.length || 1 } : {};

// fieldName verilmediğinde alanlar formun kökünde tutulur (randevulu iade formu).
const readProducts = (form, fieldName) => {
  const values = form.getFieldsValue();
  return (fieldName ? values?.[fieldName]?.products : values?.products) || [];
};

const writeToForm = ({ form, fieldName, values }) => {
  const tempForm = form.getFieldsValue();

  if (fieldName) {
    tempForm[fieldName] = { ...tempForm[fieldName], ...values };
  } else {
    Object.assign(tempForm, values);
  }

  form.setFieldsValue(tempForm);
};

export const addProductToDeliveryForm = ({
  form,
  fieldName,
  record,
  desiOptions,
  setDeliveryType,
  setDesi,
  syncTotalParcels = false,
}) => {
  const products = [...readProducts(form, fieldName), record];

  const desiValues = recalculateProductsDesi({
    products,
    desiOptions,
    setDeliveryType,
    setDesi,
  });

  writeToForm({
    form,
    fieldName,
    values: {
      products,
      ...desiValues,
      ...getParcelValues(products, syncTotalParcels),
    },
  });

  return products;
};

export const removeProductFromDeliveryForm = ({
  form,
  fieldName,
  index,
  desiOptions,
  setDeliveryType,
  setDesi,
  syncTotalParcels = false,
}) => {
  const products = [...readProducts(form, fieldName)];

  products.splice(index, 1);

  const parcelValues = getParcelValues(products, syncTotalParcels);

  if (products.length > 0) {
    const desiValues = recalculateProductsDesi({
      products,
      desiOptions,
      setDeliveryType,
      setDesi,
    });

    writeToForm({
      form,
      fieldName,
      values: { products, ...desiValues, ...parcelValues },
    });
  } else {
    writeToForm({
      form,
      fieldName,
      values: { products, manuelDesi: null, ...parcelValues },
    });
  }

  return products;
};

const computeProductDesi = (product) => {
  if (product?.width && product?.length && product?.height) {
    return Math.round((product.width * product.length * product.height) / 3000) || 1;
  }
  return Number(product?.desi || 0);
};

export const syncUpdatedProductInDeliveryForm = ({
  form,
  fieldName,
  productId,
  updatedProduct,
  desiOptions,
  setDeliveryType,
  setDesi,
}) => {
  if (!form || !productId) {
    return null;
  }

  const currentProducts = readProducts(form, fieldName);
  if (!currentProducts.length) {
    return null;
  }

  const products = currentProducts.map((product) => {
    const id = product?.id || product?._id;
    if (String(id) !== String(productId)) {
      return product;
    }

    const nextProduct = {
      ...product,
      ...updatedProduct,
      id: product?.id || productId,
      _id: product?._id || productId,
      desi: computeProductDesi({ ...product, ...updatedProduct }),
    };

    return nextProduct;
  });

  const hasMatch = products.some(
    (product, index) => products[index] !== currentProducts[index]
  );
  if (!hasMatch) {
    return null;
  }

  const desiValues = recalculateProductsDesi({
    products,
    desiOptions,
    setDeliveryType,
    setDesi,
  });

  writeToForm({
    form,
    fieldName,
    values: { products, ...desiValues },
  });

  return products;
};

export const mapProductsForApi = (products = []) => {
  const productIds = products
    .map((product) => product?.id || product?._id)
    .filter(Boolean);

  return productIds.length ? JSON.stringify(productIds) : null;
};

export const normalizeDeliveryProducts = (delivery) =>
  delivery?.products?.length ? delivery.products : [];
